<template>
  <GridContainer
    class="dcb-lp"
    padding
  >
    <Breadcrumb
      :items="breadcrumb"
      no-padding
    />

    <DCBTeaser />

    <Usp />

    <QrCodeTeaser />

    <DcbSpecials />

    <PartnerLp />

    <Faq simple />
  </GridContainer>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { GridContainer } from '@i22-td-smarthome/component-library';
import Breadcrumb from '@/components/breadcrumb.vue';

import { getHeader } from '@/helpers/page-header-compositon';
import { Track } from '@/helpers/page-tracking';
import DCBTeaser from '@/components/dcb/teaser.vue';
import QrCodeTeaser from '@/components/dcb/qr-code-teaser.vue';
import Faq from '@/components/dcb/faq.vue';
import Usp from '@/components/dcb/usp.vue';
import PartnerLp from '@/components/dcb/partner-lp.vue';
import DcbSpecials from '~/components/dcb/dcb-specials.vue';

Track();

getHeader({
  title: ref('Zahlung per Handyrechnung: Einrichtung'),
  isIndexed: ref(false),
  description: ref(
    'Entdecke die neue Art des Bezahlens: Mit der Bezahlung per Handyrechnung, kannst Du Deine Einkäufe direkt über Deine Handyrechnung zahlen. Jetzt einrichten!'
  ),
});

const breadcrumb = [
  {
    label: 'Zahlung per Handyrechnung',
    to: 'zahlung-per-handyrechnung',
  },
];
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.dcb-lp {
  &__teaser {
    @include mq($mq-sm) {
      display: grid;
      grid-template-areas: 'title image' 'copy image';
    }

    &-title {
      grid-area: title;
    }
    &-copy {
      grid-area: copy;
    }
    &-image {
      grid-area: image;
    }
  }
}
</style>
